import { HistoryDelegation } from '../../Entities/History.Delegation.Entity';
import { BaseApi } from '../index.exports';

export class HistoryDelegationFrontEndApiCalls extends BaseApi {
    protected static _Entity = HistoryDelegation;

    // #region api

    // #endregion api
}
